/* My Elegant Horse: Postin noutopisteen (SmartPOST / pakettiautomaatti) valinta ostoskorissa.
   Asiakas kirjoittaa postinumeron ja valitsee noutopisteen; valinta tallentuu tilaukseen ostoskorin lisätietoina
   ("Noutopiste" ja "Noutopiste ID"), ja hallintaportaali luo Postin lähetyksen suoraan valittuun noutopisteeseen.
   Noutopisteet haetaan M1:n julkiselta palvelimelta (Postin tunnukset pysyvät palvelimella). Jos haku ei ole käytössä,
   valintaa ei näytetä lainkaan. Teema-asset: assets/meh-noutopiste.js, ladataan layoutista meh (kaupan sivut) ja snippetistä meh-global (teeman omat sivut). */
(function () {
  var HAKU = 'https://meh-seuranta.tailac613c.ts.net/noutopisteet?postinumero=';
  // Ostoskorin sivupaneeli (meh-kassa.js: a.mehd__go) ja teeman muut kassapainikkeet
  var KASSA = 'button[name="checkout"], input[name="checkout"], a[href="/checkout"], #checkout';
  // Teeman oma ostoskorisivu (meh-ostoskori) piirtää itsensä uudelleen vertaamalla elementtejä järjestyksessä, joten valintaa ei
  // voi lisätä sen väliin jälkikäteen. Siksi sivupohjaan (script#meh-tpl) lisätään ennen piirtoa kaksi paikkaa, joiden sisältöä
  // piirto ei kosketa (data-meh-keep): valinta toimitusrivin alle tuotelistan yläpuolelle ja muistutus "Siirry kassalle" -painikkeen yläpuolelle.
  (function () {
    var t = document.getElementById('meh-tpl');
    if (!t || t.innerHTML.indexOf('meh-np-paikka') >= 0) return;
    var h = t.innerHTML, i = h.indexOf('Smartpost'), j = i >= 0 ? h.indexOf('</span></div>', i) : -1;
    if (j >= 0) { j += '</span></div>'.length; h = h.slice(0, j) + '<div id="meh-np-paikka" data-meh-keep></div>' + h.slice(j); }
    var k = h.indexOf('onClick="{{checkout}}"'), b = k >= 0 ? h.lastIndexOf('<button', k) : -1;
    if (b >= 0) h = h.slice(0, b) + '<div id="meh-np-muistutus" data-meh-keep></div>' + h.slice(b);
    t.innerHTML = h;
  })();
  var kaytossa = null, ostoskori = null;

  var tyyli = document.createElement('style');
  tyyli.textContent = '.meh-np{margin:0 0 14px;padding:16px 18px;border:1px solid #E7DFD0;border-left:4px solid #A27F35;background:#F6F2EB;font-family:Jost,"Helvetica Neue",Arial,sans-serif;color:#1A1A1A;text-align:left}' +
    '.meh-np h3{margin:0 0 4px;font-family:"Bodoni Moda",Didot,Georgia,serif;font-weight:400;font-size:18px;letter-spacing:.05em;text-transform:uppercase}' +
    '.meh-np p{margin:0 0 10px;font-size:13px;line-height:1.5;color:#6B6B6B}' +
    '.meh-np .meh-np-haku{display:flex;gap:8px}.meh-np input{flex:1;min-width:0;padding:10px 12px;border:1px solid #CFC6B5;background:#fff;font:inherit;font-size:15px}' +
    '.meh-np button{padding:10px 16px;border:0;background:#1A1A1A;color:#fff;font:inherit;font-size:12px;letter-spacing:.12em;text-transform:uppercase;cursor:pointer}' +
    '.meh-np ul{list-style:none;margin:10px 0 0;padding:0;max-height:300px;overflow:auto}' +
    '.meh-np li button{display:block;width:100%;margin:0 0 6px;padding:9px 12px;background:#fff;color:#1A1A1A;border:1px solid #E7DFD0;text-align:left;text-transform:none;letter-spacing:0;font-size:14px}' +
    '.meh-np li button:hover,.meh-np li button[aria-pressed="true"]{border-color:#A27F35;outline:1px solid #A27F35}' +
    '.meh-np small{display:block;color:#6B6B6B;font-size:12px}.meh-np .meh-np-valittu{font-size:14px;margin:0 0 8px}' +
    '.meh-kori-np{margin:16px 0 8px}.meh-np-muistutus{font-size:14px;line-height:1.5;margin:0}.meh-np-muistutus a{color:#A27F35;text-decoration:underline}' +
    '.meh-np .meh-np-linkki{background:none;color:#A27F35;padding:0;text-decoration:underline;letter-spacing:0;text-transform:none;font-size:13px}';
  document.head.appendChild(tyyli);

  function esc(t) { return String(t == null ? '' : t).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function haeOstoskori() { return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) { ostoskori = c; return c; }); }
  function tallenna(np) {
    var attr = np ? { 'Noutopiste': np.nimi + ', ' + np.osoite, 'Noutopiste ID': np.id } : { 'Noutopiste': '', 'Noutopiste ID': '' };
    return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ attributes: attr }) })
      .then(function (r) { return r.json(); }).then(function (c) { ostoskori = c; });
  }

  function piirra(laatikko) {
    var a = (ostoskori && ostoskori.attributes) || {};
    var valittu = a['Noutopiste ID'] ? a['Noutopiste'] : '';
    laatikko.innerHTML = '<h3>📦 ' + (valittu ? 'Noutopiste' : 'SmartPost-automaatti') + '</h3>' + (valittu
      ? '<div class="meh-np-valittu">' + esc(valittu) + '</div><button type="button" class="meh-np-linkki" data-vaihda>Vaihda noutopiste</button>'
      : '<p>Jos haluat tuotteet SmartPost-automaattiin, valitse automaatti tästä.</p>' +
        '<div class="meh-np-haku"><input inputmode="numeric" maxlength="5" placeholder="Postinumero, esim. 33100" aria-label="Postinumero"><button type="button" data-hae>Hae</button></div><ul></ul>');
    var vaihda = laatikko.querySelector('[data-vaihda]');
    if (vaihda) vaihda.onclick = function () { tallenna(null).then(piirraKaikki); };
    // Ei omaa <form>-elementtiä: valinta on ostoskorin lomakkeen sisällä, eikä sisäkkäisiä lomakkeita sallita
    var kentta = laatikko.querySelector('.meh-np-haku input');
    if (!kentta) return;
    kentta.onkeydown = function (ev) { if (ev.key === 'Enter') { ev.preventDefault(); hae(); } };
    laatikko.querySelector('[data-hae]').onclick = function (ev) { ev.preventDefault(); hae(); };
    function hae() {
      var pn = kentta.value.replace(/\D/g, '');
      var lista = laatikko.querySelector('ul');
      if (pn.length !== 5) { lista.innerHTML = '<li><small>Kirjoita viisinumeroinen postinumero.</small></li>'; return; }
      lista.innerHTML = '<li><small>Haetaan noutopisteitä…</small></li>';
      fetch(HAKU + pn).then(function (r) { return r.json(); }).then(function (d) {
        var l = d.noutopisteet || [];
        if (!l.length) { lista.innerHTML = '<li><small>' + esc(d.virhe || 'Noutopisteitä ei löytynyt tällä postinumerolla.') + '</small></li>'; return; }
        lista.innerHTML = l.map(function (np, i) {
          return '<li><button type="button" data-i="' + i + '">' + (np.automaatti ? '🔒 ' : '🏪 ') + esc(np.nimi) + '<small>' + esc(np.osoite) + (np.sijainti ? ' · ' + esc(np.sijainti) : '') + '</small></button></li>';
        }).join('');
        Array.prototype.forEach.call(lista.querySelectorAll('button[data-i]'), function (b) {
          b.onclick = function () { b.setAttribute('aria-pressed', 'true'); tallenna(l[Number(b.getAttribute('data-i'))]).then(piirraKaikki); };
        });
      }).catch(function () { lista.innerHTML = '<li><small>Haku ei juuri nyt onnistu. Posti toimittaa paketin lähimpään noutopisteeseesi.</small></li>'; });
    }
  }

  function muistuta(el) {
    var a = (ostoskori && ostoskori.attributes) || {};
    el.innerHTML = a['Noutopiste ID'] ? '📦 Noutopiste: ' + esc(a['Noutopiste'])
      : '📦 Noutopistettä ei ole valittu. <a href="#meh-np-kori">Valitse automaatti</a> – muuten Posti toimittaa lähimpään.';
  }
  function piirraKaikki() {
    Array.prototype.forEach.call(document.querySelectorAll('.meh-np'), piirra);
    Array.prototype.forEach.call(document.querySelectorAll('.meh-np-muistutus'), muistuta);
  }

  // Valinta jokaisen kassapainikkeen yläpuolelle (ostoskorisivu ja ostoskorin sivupaneeli; myös kun paneeli piirretään uudelleen)
  function lisaa() {
    if (kaytossa === false) return;
    var paikka = document.getElementById('meh-np-paikka');
    if (paikka && !paikka.firstChild) {
      var lk = document.createElement('div'); lk.className = 'meh-np meh-kori-np'; lk.id = 'meh-np-kori';
      paikka.appendChild(lk);
      (ostoskori ? Promise.resolve(ostoskori) : haeOstoskori()).then(function () { piirra(lk); });
    }
    var mp = document.getElementById('meh-np-muistutus');
    if (mp && !mp.firstChild) {
      var m = document.createElement('p'); m.className = 'meh-np-muistutus';
      mp.appendChild(m);
      (ostoskori ? Promise.resolve(ostoskori) : haeOstoskori()).then(function () { muistuta(m); });
    }
    Array.prototype.forEach.call(document.querySelectorAll(KASSA), function (nappi) {
      var paikka = nappi;
      if (!paikka.parentElement || (paikka.previousElementSibling && paikka.previousElementSibling.classList.contains('meh-np'))) return;
      var laatikko = document.createElement('div'); laatikko.className = 'meh-np';
      paikka.parentElement.insertBefore(laatikko, paikka);
      (ostoskori ? Promise.resolve(ostoskori) : haeOstoskori()).then(function () { piirra(laatikko); });
    });
  }
  function kaynnista() {
    // Onko haku käytössä (palvelin palauttaa virheen "ei käytössä", jos Postin tunnuksia ei ole)
    fetch(HAKU.replace('?postinumero=', '/tila')).then(function (r) { return r.json(); }).then(function (d) {
      kaytossa = !!(d && d.kaytossa);
      if (!kaytossa) return;
      lisaa();
      new MutationObserver(function () { lisaa(); }).observe(document.body, { childList: true, subtree: true });
    }).catch(function () { kaytossa = false; });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', kaynnista); else kaynnista();
})();
